var React = require('react');

function Kw (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fillOpacity":".7","d":"M0 0h682.7v512H0z"}))),React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt","clipPath":"url(#a)","transform":"scale(.9375)","key":1},[React.createElement("path",{"fill":"#fff","d":"M0 170.6h1024v170.7H0z","key":0}),React.createElement("path",{"fill":"#f31830","d":"M0 341.3h1024V512H0z","key":1}),React.createElement("path",{"fill":"#00d941","d":"M0 0h1024v170.7H0z","key":2}),React.createElement("path",{"d":"M0 0v512l255.4-170.7.6-170.8L0 0z","key":3})])]);
}

Kw.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Kw;

Kw.default = Kw;
